import StarterKit from '@tiptap/starter-kit';
import Placeholder from '@tiptap/extension-placeholder';

/**
 * Free/MIT extension set for the SOP editor — a single flowing rich-text
 * document. StarterKit gives headings, paragraphs, bullet + ordered lists (with
 * nesting), bold/italic and the standard keymap (Enter, Tab/Shift-Tab indent,
 * Backspace merge). Extras we don't want (blockquote, code, horizontal rule,
 * strike) are disabled. Placeholder hints show on empty nodes while editing.
 *
 * mode: 'full' | 'client' add the placeholder; 'view' / 'static' omit it.
 */
const sopPlaceholder = ({ node, pos, editor }) => {
  if (node.type.name === 'heading') return 'Section heading';
  if (node.type.name === 'paragraph') {
    try {
      if (editor.state.doc.resolve(pos).parent.type.name === 'listItem') return 'List item';
    } catch (e) {
      /* fall through */
    }
    return 'Write here…';
  }
  return '';
};

export function buildSopExtensions({ mode = 'full' } = {}) {
  const extensions = [
    StarterKit.configure({
      heading: { levels: [2, 3] },
      blockquote: false,
      code: false,
      codeBlock: false,
      horizontalRule: false,
      strike: false,
    }),
  ];

  if (mode === 'full' || mode === 'client') {
    extensions.push(
      Placeholder.configure({
        includeChildren: true,
        placeholder: sopPlaceholder,
      })
    );
  }

  return extensions;
}
